import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { TerminalResponse } from '@/repositories/generated';

const response: TerminalResponse[] = [
  {
    id: 'mock0000000100001',
  },
  {
    id: 'mock0000000100002',
  },
  {
    id: 'mock0000000100003',
  },
];

export const autocompleteTerminal = http.get(
  createMockEndpoint('/autocomplete/terminal'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
